module["exports"] = [
  "街",
  "路",
  "北路",
  "南路",
  "東路",
  "西路"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/zh_TW/address/street_suffix.js
// module id = 2108
// module chunks = 1